// region Website config
export const MAIN_SIDEBAR_EXTEND_WIDTH = 256
export const MAIN_SIDEBAR_COLLAPSE_WIDTH = 64
export const MAIN_SIDEBAR_DRAWER_WIDTH = 256
export const MAIN_HEADER_HEIGHT = 64
export const APP_NAME = 'validus'
export const LONG_DATE = 'DD-MM-YYYY HH:mm'
export const PAGES = {
  LOGIN: {
    PATH: '/login',
    NAME: 'login',
  },
  I18N: {
    PATH: '/i18n',
    NAME: 'i18n',
  },

  ABOUT_US: {
    PATH: '/about-us',
    NAME: 'about-us',
  },
  TEST: {
    PATH: '/test',
    NAME: 'test',
  },
  HOME: {
    PATH: '/',
    NAME: 'home',
  },
  LOOKUP_ACCOUNT: {
    PATH: '/chon-tai-khoan-so-dep',
    NAME: 'lookup-account',
  },
}

export const RESPONSE_CODE = {
  SUCCESS: '200', // Thành công
  UN_AUTHORIZE: '401', // Hết phiên
}

export const THEME = {
  PRIMARY_COLOR: '#00B74F',
  COMPONENT_COLOR: '#00B74F',
  BORDER_RADIUS: 4,
}
export const BREAKPOINT = {
  XS: 'XS', // width < 576
  SM: 'SM', // 576 <= width < 768
  MD: 'MD', // 768 <= width < 992
  LG: 'LG', // 992 <= width < 1200
  XL: 'XL', // 1200 <= width < 1600
  XXL: 'XXL', // width >= 1600
}
export const CONTAINER_WIDTH = {
  XXL: 85,
  XL: 85,
  LG: 80,
  MD: 90,
  SM: 100,
  XS: 100,
}
export const ERROR_COLOR = 'red'
export const ERROR_TITLE = 'Thông báo'
export const SUCCESS_TITLE = 'Thông báo'
export const SUCCESS_COLOR = '#52c41a'
export const INFO_COLOR = '#0465B0'
export const INFO_TITLE = 'Thông báo'
export const WARNING_COLOR = '#faad14'
export const WARNING_TITLE = 'Cảnh báo'
export const REDIRECT_LOGO_LINK = 'https://www.vpbank.com.vn/doanh-nghiep-vua-va-nho'
export const SELECT_ACCOUNT_LENGTH = [
  {
    label: 'Từ 3-6 ký tự',
    value: '3-6',
    maxLength: 6,
  },
  {
    label: 'Từ 7-9 ký tự',
    value: '7-9',
    maxLength: 9,
  },
  {
    label: 'Từ 10-12 ký tự',
    value: '10-12',
    maxLength: 12,
  },
  {
    label: 'Từ 13-15 ký tự',
    value: '13-15',
    maxLength: 15,
  },
]
export const SELECT_ACCOUNT_LENGTH_EXACTLY = () => {
  let arr = []
  for (let i = 3; i <= 15; i++) {
    arr.push({
      label: `${i}`,
      value: i,
      length: i,
    })
  }
  return arr
}
export const SELECT_ACCOUNT_NUMBER_PRICE = [
  {
    label: 'Tất cả mức giá',
    value: '',
  },
  {
    label: 'Miễn phí',
    value: '0-0',
  },
  {
    label: 'Từ 1 - dưới 5 triệu đồng',
    value: '1-5',
  },
  {
    label: 'Từ 5 - dưới 10 triệu đồng',
    value: '5-10',
  },
  {
    label: 'Từ 10 - dưới 15 triệu đồng',
    value: '10-15',
  },
  {
    label: 'Từ 15 – dưới 20 triệu đồng',
    value: '15-20',
  },
  {
    label: 'Từ 20 - dưới 25 triệu đồng',
    value: '20-25',
  },
  {
    label: 'Từ 25 – dưới 50 triệu đồng',
    value: '25-50',
  },
  {
    label: 'Từ 50 triệu đồng',
    value: '50-50',
  },
]
export const SELECT_DOCUMENT_TYPE_LIST = [
  {
    label: 'ĐKKD',
    value: 'DKKD',
  },
  {
    label: 'QĐ thành lập',
    value: 'QDTL',
  },
]
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY
export const TEMPLATE_CODE = 'EMAIL_SN_ON_BC'
export const TEMPLATE_CODE_RELEASE = 'EMAIL_SN_ON_BC_RELEASE'
export const PRODUCT_TYPE = 'LANDINGPAGE'
export const REQUEST_BUILDER = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE',
}
// endregion
